import { defineMessages } from 'react-intl'

export const paymentsPageMessages = defineMessages({
  title: {
    id: 'paymentsPage.title',
    description: 'Payment methods page title',
    defaultMessage: 'Payment Methods',
  },
})
